import { Box, Loader } from "@saviynt/design-system";
import "./PoliciesForm.css";
import { Policy } from "@repo/api/schemas/policies.schema";
import { PoliciesFormProvider } from "./PoliciesFormContext";
import PoliciesFormHeader from "./PoliciesFormHeader/PoliciesFormHeader";
import PoliciesFormContent from "./PoliciesFormContent";
import { useGetPolicyById } from "../../hooks/usePolicy";

export type ActionType = "new" | "edit" | "clone";
interface PolicyFormProps {
  actionType: ActionType;
  policyId?: string;
}

function PoliciesFormInner({
  actionType,
  policyData,
}: {
  actionType: ActionType;
  policyData?: Policy;
}) {
  return (
    <Box className="Policies-Form w-full">
      <PoliciesFormHeader actionType={actionType} policyData={policyData} />
      <PoliciesFormContent />
    </Box>
  );
}

export default function PoliciesForm({
  actionType,
  policyId,
}: PolicyFormProps) {
  const isEditOrClone = actionType === "edit" || actionType === "clone";
  const { data: policyData, isLoading } = useGetPolicyById(
    isEditOrClone ? (policyId ?? "") : "",
  );

  if (isEditOrClone && isLoading)
    return (
      <div className="flex items-center justify-center py-4">
        <Loader kind="loop" format="inline" color="brand" />
      </div>
    );

  const {
    processor = "",
    evaluationCriteria = "",
    query = "",
  } = policyData?.rule_definition ?? {};

  const evalCriteria = processor || evaluationCriteria || query;

  const initialValues =
    isEditOrClone && policyData
      ? {
          name: policyData.name,
          description: policyData.description,
          severity: policyData.severity,
          tags: Array.isArray(policyData.metadata?.tags)
            ? policyData.metadata.tags
            : (policyData.metadata?.tags?.split(",") ?? []),
          evaluationCriteria: evalCriteria,
        }
      : undefined;

  return (
    <PoliciesFormProvider initialValues={initialValues}>
      <PoliciesFormInner actionType={actionType} policyData={policyData} />
    </PoliciesFormProvider>
  );
}
